import React from 'react'
import { Button } from '@roo/roo'
import { getHost } from '../../utils'
import buggerIcon from '../../assets/images/error.svg'
import styles from './error.less'

const returnBack = () => {
  const url = `${getHost()}/partner`
  window.top ? window.top.location.href = url : window.location.href = url
}
export default (
  <div className={styles.errorMain}>
    <img src={buggerIcon} />
    <span className={styles.errorMainText}>ERROR</span>
    <Button onClick={() => returnBack()}>GO HOME</Button>
  </div>
)
